import { execGet } from 'services/RequestUtils';

export function getPMOLink(): Promise<string> {
  return execGet<string>(`${process.env.REACT_APP_OFFICE_API}/pmo/link`, {
    contentTypeHeader: 'text/plain',
    cache: false
  });
}
